import { AxiosResponse } from 'axios';

import api from 'utils/apiClient';

import {
  IContract,
  IPaginationParams,
  IPaginationResponse,
  IPayout,
  ICashFlowData,             
  ICalculationParametersData 
} from 'types';

export const loadContracts = (params: IPaginationParams): Promise<AxiosResponse<IPaginationResponse<IContract>>> => {
  return api.get('/contracts', { params });
};

export const loadContractPayouts = (idContract: number): Promise<AxiosResponse<IPaginationResponse<IPayout[]>>> => {
  return api.get(`/payments/${idContract}` );
};

export const loadCashFlows = (idContract: number): Promise<AxiosResponse<ICashFlowData>> => {
  return api.get(`/contract/${idContract}/cashflows`);
};

export const loadCalculationParameters = (idContract: number): Promise<AxiosResponse<ICalculationParametersData>> => {
  return api.get(`/contract/${idContract}/calcparams`);
};

export const downloadContractOplataExcel = (
  idContract: number
): Promise<AxiosResponse<Blob>> => {
  return api.get(`/contract/${idContract}/export`, {
    responseType: 'blob',
  });
};


export const sendForm = (formData: any): Promise<AxiosResponse<any>> => {
  return api.post('/send-order-confirmation', formData);
};
